import { Table, Button, Form, Modal, Row, Dropdown } from "react-bootstrap";
import {
  CalendarIcon,
  DeleteIcon,
  EditIcon,
  GearIcon,
  PrintIcon,
} from "./../Icons";
import "./../../assets/scss/reports/cashbook.scss";
import { useEffect, useRef, useState } from "react";
import DateRangePicker from "../utils/DateRangePicker";
import CachedIcon from "mdi-react/CachedIcon";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import ChevronUpIcon from "mdi-react/ChevronUpIcon";
import { reportActions } from "../../utils/reactQueryActions";
import useDebounce, {
  useBackendUrl,
  useEffectOnce,
  useIsAdmin,
  useQueryParams,
  useScrollTop,
} from "../../utils/hooks";
import queryString from "query-string";
import { services } from "../../config";
import { useMutation, useQuery } from "react-query";
import currency from "currency.js";
import { format, parse } from "date-fns";
import ReactPaginate from "react-paginate";
import { paginationOptions, scrollToTop } from "../../utils/helpers";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import { useAuth } from "../../hooks/useAuth";
import PageHeader from "../PageHeader";
import { useFormik } from "formik";
import * as yup from "yup";
import Select from "react-select";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import { toast } from "react-toastify";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { isEmpty } from "lodash";
import LoginDialog from "../LoginDialog";
import ConfirmDialog from "../ConfirmDialogue";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { UnAuthorized } from "../utils/UnAuthorized";
import { fetchActionsUtil } from "../../utils/helpers";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import NoTableItem from "../utils/NoTableItem";

const initialValues = {
  TransType: "",
  oldTransType: "",
};
const schema = yup.object().shape({
  TransType: yup.string().required(),
});

function CreateInvoiceAccountsMappingModal({
  showCreateInvoiceAccountsMappingModal,
  setShowCreateInvoiceAccountsMappingModal,
  refetch,
}) {
  const backendUrl = useBackendUrl();

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      createInvoiceAccountsMappingMutation.mutate({ ...values });
    },
  });

  const createInvoiceAccountsMapping = async (payload) => {
    let response = await fetch(
      `${backendUrl}/api/customers/create-trans-type`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const createInvoiceAccountsMappingMutation = useMutation(
    (payload) => createInvoiceAccountsMapping(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        formik.resetForm();
        refetch();
        setShowCreateInvoiceAccountsMappingModal(false);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  return (
    <Modal
      show={showCreateInvoiceAccountsMappingModal}
      onHide={() => setShowCreateInvoiceAccountsMappingModal(false)}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1 className="h6">Create Customer Type</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Control
              name="TransType"
              placeholder="Type"
              type="text"
              value={formik.values.TransType}
              onChange={formik.handleChange}
              isInvalid={formik.touched.TransType && !!formik.errors.TransType}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.TransType}
            </Form.Control.Feedback>
          </Form.Group>

          <Button
            disabled={createInvoiceAccountsMappingMutation.isLoading}
            variant="primary"
            className="w-100 p-2"
            type="submit"
          >
            {createInvoiceAccountsMappingMutation.isLoading ? "Please wait…" : "Create Now"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default function InvoiceAccountsMapping() {
  const { backendUrl, token } = useAuth();
  const isAdmin = useIsAdmin();
  const [showCreateInvoiceAccountsMappingModal, setShowCreateInvoiceAccountsMappingModal] = useState(
    false
  );
  const [showEditInvoiceAccountsMappingModal, setShowEditInvoiceAccountsMappingModal] = useState(false);
  const [selectedTransType, setSelectedTransType] = useState({});

  useScrollTop();
  const initialFilterParams = { q: "" };
  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  const getInvoiceAccountsMapping = async (debouncedqueryParams) => {
    let response = await fetch(
      `${backendUrl}/api/customers/trans-type?${queryString.stringify(
        debouncedqueryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    return data;
  };

  const {
    data = { InvoiceAccountsMapping: [] },
    refetch,
    isFetching,
    isSuccess,
  } = useQuery(
    ["GET_BUISINESS_InvoiceAccountsMapping", queryParams],
    () => getInvoiceAccountsMapping(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const deleteInvoiceAccountsMapping = async (payload) => {
    let response = await fetch(
      `${backendUrl}/api/customers/delete-trans-type`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteInvoiceAccountsMappingMutation = useMutation(
    (payload) => deleteInvoiceAccountsMapping(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
      page: 1,
    });
  };

  const handleEdit = async (TransType) => {
    setSelectedTransType(null);
    if (await LoginDialog()) {
      setSelectedTransType(TransType);
      setShowEditInvoiceAccountsMappingModal(true);
    }
  };

  const handleDelete = async (TransType) => {
    if (await LoginDialog()) {
      if (
        await ConfirmDialog({
          title: "Delete Type",
          description: "Are you sure you want to delete this Type",
        })
      ) {
        deleteInvoiceAccountsMappingMutation.mutate({ ...TransType });
      }
    }
  };

  return (
    <>
      {isAdmin ? (
        <main className="bg-white">
          {" "}
          <header className="p-4">
            <div className="search-area d-flex flex-wrap justify-content-between gap-3 w-100">
              <div className="d-flex flex-wrap gap-3 col-md-4">
                <div className="global-search-area w-75">
                  <MagnifyIcon />
                  <Form.Control
                    className=""
                    name="q"
                    value={filterParams.q}
                    onChange={(e) => handleSearchQueryChange(e)}
                    placeholder="Search Customer Type..."
                  />
                </div>
                <Button
                  onClick={() => refetch()}
                  variant=""
                  className="bg-light-blue border-0 text-primary"
                >
                  <CachedIcon />
                </Button>
              </div>

              <div className="actions mr-5">
                <Button
                  onClick={() => setShowCreateInvoiceAccountsMappingModal(true)}
                  className="px-3"
                >
                  + Create New
                </Button>
              </div>
            </div>
          </header>
          <div className="content">
            <div className="px-md-4">
              <Table responsive borderless striped className="product-table">
                <thead>
                  <tr>
                    <th />
                    <th>S/N</th>
                    <th>Title</th>
                    <th>Accounts</th>
                    <th>Date Created</th>
                  </tr>
                </thead>
                <tbody>
                  {data.InvoiceAccountsMapping?.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {/*   <Dropdown>
                          <Dropdown.Toggle
                            variant=""
                            className="bg-white border-0"
                            bsPrefix="print more"
                          >
                            <DotsHorizontalIcon />
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            popperConfig={{
                              strategy: "fixed",
                            }}
                            renderOnMount
                            className="dropdown-with-icons"
                          >
                            <Dropdown.Item
                              as="button"
                              onClick={() => handleEdit(el)}
                            >
                              <EditIcon /> Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              as="button"
                              onClick={() => handleDelete(el)}
                            >
                              <DeleteIcon /> Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                      </td>

                      <td>{index + 1}</td>
                      <td>{el.title}</td>
                      <td>{""}</td>
                      <td>{""}</td>
                      <td>{""}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {!isFetching && isSuccess && isEmpty(data?.InvoiceAccountsMapping) ? (
                <div>
                  <NoTableItem queryParams={queryParams} />
                </div>
              ) : null}
            </div>
          </div>
          {showCreateInvoiceAccountsMappingModal && (
            <CreateInvoiceAccountsMappingModal
              showCreateInvoiceAccountsMappingModal={showCreateInvoiceAccountsMappingModal}
              setShowCreateInvoiceAccountsMappingModal={setShowCreateInvoiceAccountsMappingModal}
              refetch={refetch}
            />
          )}
          {!isEmpty(selectedTransType) && (
            <EditInvoiceAccountsMappingModal
              showEditInvoiceAccountsMappingModal={showEditInvoiceAccountsMappingModal}
              setShowEditInvoiceAccountsMappingModal={setShowEditInvoiceAccountsMappingModal}
              selectedTransType={selectedTransType}
              setSelectedTransType={setSelectedTransType}
              refetch={refetch}
            />
          )}
        </main>
      ) : (
        <UnAuthorized />
      )}
    </>
  );
}

function EditInvoiceAccountsMappingModal({
  showEditInvoiceAccountsMappingModal,
  setShowEditInvoiceAccountsMappingModal,
  selectedTransType = {},
  refetch,
  setSelectedTransType,
}) {
  const backendUrl = useBackendUrl();

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      editInvoiceAccountsMappingMutation.mutate({
        ...values,
      });
    },
  });

  useEffectOnce(() => {
    formik.setValues({
      TransType: selectedTransType.TransType,
      oldTransType: selectedTransType.TransType,
    });
  });

  const editInvoiceAccountsMapping = async (payload) => {
    let response = await fetch(
      `${backendUrl}/api/customers/update-trans-type`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const editInvoiceAccountsMappingMutation = useMutation(
    (payload) => editInvoiceAccountsMapping(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        formik.resetForm();
        refetch();
        setShowEditInvoiceAccountsMappingModal(false);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  return (
    <Modal
      show={showEditInvoiceAccountsMappingModal}
      onHide={() => {
        setSelectedTransType(null);
        setShowEditInvoiceAccountsMappingModal(false);
      }}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1 className="h6">Edit {formik.values.oldTransType}</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Control
              name="TransType"
              placeholder="Type"
              type="text"
              value={formik.values.TransType}
              onChange={formik.handleChange}
              isInvalid={formik.touched.TransType && !!formik.errors.TransType}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.TransType}
            </Form.Control.Feedback>
          </Form.Group>

          <Button
            disabled={editInvoiceAccountsMappingMutation.isLoading}
            variant="primary"
            className="w-100 p-2"
            type="submit"
          >
            {editInvoiceAccountsMappingMutation.isLoading ? "Please wait…" : "Save Changes"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
